/* eslint-disable import/no-named-as-default */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
// import CompanyFilter from './CompanyFilter';
import DateFilter from "./DateFilter";
import { FiltersWrapper, MobileCloseBtn } from "./filters-styles";

export class Filters extends Component {
  state = {
    companyFilterShown: false,
    mobileFilterActive: false,
  };

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside, false);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside, false);
  }

  toggleCompanyFilter = () => {
    const { companyFilterShown, mobileFilterActive } = this.state;

    this.setState({
      companyFilterShown: !companyFilterShown,
      mobileFilterActive: !mobileFilterActive,
    });
  };

  // uncomment this when Company Filter is added
  // handleClickOutside = (e) => {
  //   const companyFilter = document.getElementById('company-filter');

  //   if (!companyFilter.contains(e.target)) {
  //     this.setState({ companyFilterShown: false });
  //   }
  // };

  render() {
    const { /* companyFilterShown, */ mobileFilterActive } = this.state;
    const { datePickerActive, hubAdminPresent } = this.props;

    return (
      <FiltersWrapper
        data-id="employer-analytics-filters"
        id="employer-analytics-filters"
        className="animated fadeIn delay-1"
        datePickerActive={datePickerActive}
        mobileFilterActive={mobileFilterActive}
      >
        {/*
        {!datePickerActive && (
          <CompanyFilter
            companyFilterShown={companyFilterShown}
            toggleCompanyFilter={this.toggleCompanyFilter}
            hubAdminPresent={hubAdminPresent}
          />
        )}
        */}
        <DateFilter hubAdminPresent={hubAdminPresent} />
        {datePickerActive && <MobileCloseBtn>close</MobileCloseBtn>}
      </FiltersWrapper>
    );
  }
}

Filters.propTypes = {
  datePickerActive: PropTypes.bool.isRequired,
  hubAdminPresent: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  datePickerActive: state.employerAnalytics.datePickerActive,
});

export default connect(mapStateToProps, {})(Filters);
